<template>
  <v-card color="rgba(0, 0, 0, 0.5)">
    <v-card-title>
      <div class="d-flex">
        <p class="text-caption white--text font-weight-bold">API</p>
        <p class="text-caption white--text pl-2">
          {{ apiURL || "localhost:8000" }}
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark small @click="$emit('openConfigDialog')">
        <v-icon>mdi-power-plug-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="formLoginValid" ref="form">
        <div>
          <v-text-field
            label="Nome do Usuário"
            type="text"
            v-model="form.username"
            :rules="formRules.usernameRules"
            dark
          ></v-text-field>
          <v-text-field
            label="Senha do Usuário"
            :type="showPass? 'text' : 'password'"
            v-model="form.password"
            :rules="formRules.passwordRules"
            dark
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPass = !showPass"
          ></v-text-field>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="teal lighten-1" dark @click="$emit('openGuestDialog')">
        <v-icon small left>mdi-login</v-icon>
        <div>Convidado</div>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success"
       class="ml-auto" @click="validate()" 
        @shortkey="validate()"
        v-shortkey.once="['enter']">
        <v-icon small left>mdi-login</v-icon>
        <div>Acessar</div>
      </v-btn>      
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => {
    return {
      showPass: false,
      form: {
        username: "",
        password: "",
      },
      formRules: {
        usernameRules: [
          (v) => !!v || "Este campo é obrigatório.",
          (v) =>
            v.length >= 4 ||
            "Nome de usuário deve ter pelo menos 4 caracteres.",
          (v) =>
            v.length <= 20 ||
            "Nome de usuário dete ter menos de 20 caracteres.",
        ],
        passwordRules: [
          (v) => !!v || "Este campo é obrigatório.",
          (v) =>
            v.length >= 4 || "A senha deve possuir pelo menos 4 caracteres.",
        ],
      },
      formLoginValid: false,
    };
  },
  computed: {
    ...mapState("systemModule", ["apiURL"]),
  },
  methods: {
    ...mapActions({
      loginUser: "authModule/loginUser",
      showLoadingDialog: "dialogModule/setShowLoadingDialog",
      setLoadingDialogMessage: "dialogModule/setLoadingDialogMessage",
    }),
    async validate() {
      try {
        this.$refs.form.validate();

        if (this.formLoginValid) {
          this.setLoadingDialogMessage("Autenticando acesso...");
          this.showLoadingDialog(true);

          let loginData = {};
          loginData.NOME = this.form.username.toUpperCase();
          loginData.password = this.form.password;

          await this.loginUser(loginData);
          this.$toasted.success('Usuário autenticado com sucesso');
          this.$router.push({ name: "Home" });
        } else {
          this.$toasted.error('Prencha corretamente o formulário.',{duration: null})
        }
      } catch (err) {
          this.$toasted.error(err, {duration:null})        
      } finally {
        this.showLoadingDialog(false);
      }
    },
  },
};
</script>

<style>
</style>